import { FormatMask } from './FormatMask';

const formatSerializedId = (serializedId) => {
  if (serializedId === undefined || serializedId === null || serializedId === '') {
    return '-';
  }

  const formatMask = new FormatMask();
  const number = String(serializedId)
    .replace('@c.us', '')
    .replace('@s.whatsapp.net', '')
    .trim();

  if (!number) {
    return '-';
  }

  const masked = formatMask.setPhoneFormatMask(number);
  if (masked == null || masked === '') {
    return '-';
  }
  return String(masked).replace('+55', '🇧🇷');
};

export default formatSerializedId;
